import React, { useMemo } from "react";
import { LanguageBar } from "./LanguageBar";
import { useTranslation } from "react-i18next";
import useHashLocation from "../../../use-hash-location";
import { useSnapshot } from "valtio";
import store from "../../../appStore";

function LanguageMenu() {
  const { i18n } = useTranslation();
  const [location, setLocation] = useHashLocation();

  const snap = useSnapshot(store);

  const languagesArray = useMemo(() => {
    const languageSettings = snap.languages.map((l) => {
      return {
        name: l.displayName,
        locale: l.locale,
        function: () => {
          setLang(l.locale);
        },
      };
    });
    return languageSettings;
  }, [snap.languages]);

  function handleClick(locale) {
    var location = window.location.hash;

    var prevLanguage = languagesArray.find((l) => location.startsWith(`#/${l.locale}`));

    var newLocation = location.replace(`#/${prevLanguage.locale}`, ``);
    setLocation(newLocation);
  }

  const setLang = (lang) => {
    i18n.changeLanguage(lang);
    handleClick(lang);
  };

  const langContainerCustomStyle = {
    width: "max-content",
    padding: "0.6vw",
    border: "1px solid #fff",
    marginTop: "1vw",
  };

  const triangleCustomStyle = {
    position: "absolute",
    backgroundColor: "#fff",
    clipPath: "polygon(50% 0, 100% 100%, 0 100%)",
    width: "0.8vw",
    height: "0.5vw",
    zIndex: "999999999999999999999",
    // top: "1.6vw",
  };

  const insideTriangle = {
    position: "absolute",
    top: "0.16vh",
    left: "0.06vw",
    backgroundColor: "#222",
    clipPath: "polygon(50% 0, 100% 100%, 0 100%)",
    width: "0.7vw",
    height: "0.45vw",
    zIndex: "99999999999999999999999",
  };

  const currentLangText = useMemo(() => {
    const langText = languagesArray.find((l) => {
      return l.locale === i18n.language;
    });

    return langText ? langText.name : "";
  }, [i18n.language]);

  return (
    <div
      style={{
        pointerEvents: "auto",
      }}
    >
      <LanguageBar
        languageName={currentLangText}
        languageNameColor={"#fff"}
        iconColor={"#3EBA7C"}
        barBackgroundColor="#222"
        languagesColor={"#fff"}
        languagesArray={languagesArray}
        borderRadius={false}
        langContainerCustomStyle={langContainerCustomStyle}
        triangleCustomStyle={triangleCustomStyle}
        insideTriangle={insideTriangle}
        showArrowIcon={true}
        // showGlobeIcon={true}
      />
    </div>
  );
}

export default LanguageMenu;

const CustomIcon = () => {
  return (
    <svg
      style={{
        paddingRight: "0.5rem",
      }}
      width="0.9vw"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="#fff"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
};
